import * as yup from "yup";

export const FormSchema = yup.object({
  address: yup.string().required('Este campo es requerido'),
  province_id: yup.string().required('Este campo es requerido'),
  municipality_id: yup.string().required('Este campo es requerido'),
  sector_id: yup.string().required('Este campo es requerido'),
  phone: yup.string().required('Este campo es requerido'),
  phoneResidential: yup.string().required('Este campo es requerido'),

  notificationsWithEmail: yup.boolean(),
  notificationsSms: yup.boolean(),
}).required();
/*
export const FormPasswordSchema = yup.object({
  //old_password: yup.string().min(6, 'La contraseña debe tener minimo 6 caracteres').required('Este campo es requerido'),
  password: yup.string().min(6, "La contraseña debe incluir mínimo 6 caracteres")
    .test("isValidPass", "La contraseña debe incluir un caracter mayúscula,minúscula y un símbolo o numero", (value, context) => {
      const hasUpperCase = /[A-Z]/.test(value);
      const hasLowerCase = /[a-z]/.test(value);
      const hasNumber = /[0-9]/.test(value);
      // const hasSymbole = /[!@#%&]/.test(value);
      let validConditions = 0;
      const numberOfMustBeValidConditions = 3;
      const conditions = [hasLowerCase, hasUpperCase, /*hasNumber, /*hasSymbole ];
      conditions.forEach((condition) =>
        condition ? validConditions++ : null
      );
      if (validConditions >= numberOfMustBeValidConditions) {
        return true;
      }
      return false;
    }).required('Este campo es requerido'),
  new_password_confirmation: yup.string().min(6, 'La contraseña debe tener minimo 6 caracteres')
    .oneOf([yup.ref('password'), null], 'Las contraseñas no coinciden').required('Este campo es requerido'),

}).required();
*/
export const FormEmailSchema = yup.object({
  password: yup.string().min(6, 'La contraseña debe tener minimo 6 caracteres').required('Este campo es requerido'),
  email: yup.string().email('Ingrese un email valido').required('Este campo es requerido'),
  new_email_confirmation: yup.string().email('Ingrese un email valido')
    .oneOf([yup.ref('email'), null], 'Los correos no coinciden').required('Este campo es requerido'),

}).required();


export const FormUserExtenalSchema = yup.object({
  password: yup.string().min(6, 'La contraseña debe tener minimo 6 caracteres').required('Este campo es requerido'),
  new_password_confirmation: yup.string().min(6, 'La contraseña debe tener minimo 6 caracteres')
    .oneOf([yup.ref('password'), null], 'Las contraseñas no coinciden').required('Este campo es requerido'),

}).required();

export const FormRegisterExtenalSchema = yup.object({
  password: yup.string().min(6, 'La contraseña debe tener minimo 6 caracteres').required('Este campo es requerido'),
  new_password_confirmation: yup.string().min(6, 'La contraseña debe tener minimo 6 caracteres')
    .oneOf([yup.ref('password'), null], 'Las contraseñas no coinciden').required('Este campo es requerido'),

}).required();